import script from "./technologiesList.vue?vue&type=script&lang=ts&setup=true"
export * from "./technologiesList.vue?vue&type=script&lang=ts&setup=true"

import "./technologiesList.vue?vue&type=style&index=0&id=d57f6166&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d57f6166"]])

export default __exports__